import * as ActionsFactory from './actions-factory';
import * as EpicsFactory from './epics-factory';
import * as ReducerFactory from './reducer-factory';
import * as SelectorsFactory from './selectors-factory';
const makeCreateEntity = (dispatch, isDevelopment, onEntityInstanceCreated, onEntityInstanceDeleted, RESTClient, handleDeleteConfirm) => (configuration) => {
    const { domain, model, reducerExtension, apiDescription = {}, entityName, entityRelations = [], groupByKeys, entityIdentifier, } = configuration;
    const actions = ActionsFactory.createActions(domain, apiDescription, dispatch, isDevelopment);
    const reducer = ReducerFactory.createReducer(actions, reducerExtension, groupByKeys, entityIdentifier);
    const { epics, observables } = EpicsFactory.createEpics(apiDescription, actions, model, entityName, entityRelations, onEntityInstanceCreated, onEntityInstanceDeleted, RESTClient, handleDeleteConfirm);
    const reduxKeyPath = ReducerFactory.getReduxKeyPath(domain);
    const selectors = SelectorsFactory.createSelectors(reduxKeyPath, apiDescription, entityRelations, groupByKeys);
    return {
        domain,
        model,
        actions,
        reducer,
        epics,
        observables,
        selectors,
    };
};
/*
 * Creates EntityFactory that can create entities with
 * reducers, epics, actions and selectors for
 * a specific app (Famly App, Sign-In App)
 */
export const entityFactoryCreator = (dispatch, isDevelopment, onEntityInstanceCreated, onEntityInstanceDeleted, RESTClient, handleDeleteConfirm) => ({
    createEntity: makeCreateEntity(dispatch, isDevelopment, onEntityInstanceCreated, onEntityInstanceDeleted, RESTClient, handleDeleteConfirm),
});
